import {BrowserRouter} from 'react-router-dom';
import {QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {ThemeProvider} from '@theme/ThemeProvider';
import {ErrorBoundary} from '@components/common/ErrorBoundary';
import {AppRoutes} from '@/routes';
import {queryClient} from '@/api/queryClient';
import {useProactiveSessionRefresh} from '@/hooks/useProactiveSessionRefresh';

function App() {
    // Proactively refresh session token before expiry
    useProactiveSessionRefresh({skewMs: 60_000, minIntervalMs: 60_000, maxAttempts: 3});
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </ThemeProvider>
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
